module.exports = __webpack_public_path__ + "img/advantage_002.48b37024.png";